var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"fade-in-up"}},[_c('my-profile')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }